import axios from 'axios';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Global, { getUnreadedAds, getUnReadedChats, getUnreadedOrders, getUnreadedProducts, getUnreadedSales, isAdminAccount, isAuthenticated, isBusinessAccountType, isReadedAd, isReadedOrder, isReadedProduct, isReadedSale, isStripePaymentConnected, onUserLogout, saveUnreadedAds, saveUnreadedChats, saveUnreadedOrders, saveUnreadedProducts, saveUnreadedSales } from '../util/Global';
import { AlertContext } from '../util/Alerter';
import { LanguageContext } from '../util/LanguageSelector';
import { LanguageSelectorComponent } from './LanguageSelector';
import NotFound from './NotFound';
import { useMediaQuery, useTheme } from '@mui/material';
import { CurrencySelectorComponent } from './CurrencySelector';
import { CurrencyContext, HeaderLanguageCurrency } from './Utils';
import NewReleasesIcon from '@mui/icons-material/NewReleases';



export const DashboardHeaderContext = createContext()

export default function DashboardHeader() {
    const location = useLocation()
    const { t } = useTranslation()
    const { showAlert } = useContext(AlertContext)
    const [userData, setuserData] = useState()
    const navigate = useNavigate()

    // shared dashboard context values
    // stats values
    const [unreadedChatUserIds, setunreadedChatUserIds] = useState(getUnReadedChats());
    const [countUnreadedSales, setcountUnreadedSales] = useState(getUnreadedSales());
    const [countUnreadedProducts, setcountUnreadedProducts] = useState(getUnreadedProducts());
    const [countUnreadedOrders, setcountUnreadedOrders] = useState(getUnreadedOrders());
    const [countUnreadedAds, setcountUnreadedAds] = useState(getUnreadedAds());

    // user values
    const [firstName, setfirstName] = useState(localStorage.getItem("prenom"))
    const [lastName, setlastName] = useState(localStorage.getItem("nom"))
    const [photo, setphoto] = useState((localStorage.getItem("photo") && localStorage.getItem("photo") != "null") ? localStorage.getItem("photo") : (isBusinessAccountType() ? localStorage.getItem("logo") : null))

    // page header values
    const [isAdminPath, setisAdminPath] = useState(false)
    const [navLinks, setnavLinks] = useState([])
    const [pageTitle, setpageTitle] = useState("")
    const [pageNavLink, setpageNavLink] = useState({ path: "", label: "" })
    const [alertTitle, setalertTitle] = useState("")




    // API
    const MYPRODUCTS_URL = Global.backend + "/index.php/produit/myProducts";
    const SALES_URL = Global.backend + "/index.php/api/commande/showSales";
    const LAST_MESSAGE_URL = Global.backend + "/index.php/api/message/lastmessage";
    const ORDERS_URL = Global.backend + "/index.php/api/commande/showOrders";
    const ADS_URL = Global.backend + "/index.php/myAds";
    const USER_URL = Global.backend + "/index.php/user/show";


    useEffect(() => {
        if (!isAuthenticated()) {
            return navigate("/login")
        }
        setisAdminPath(location.pathname.startsWith("/dashboard/admin"))



        if (userData && isBusinessAccountType() && !isStripePaymentConnected()) {
            setalertTitle(t("setupPaymentSettings"))
        }
    }, [location, userData]);



    useEffect(() => {
        if (!isAuthenticated()) {
            return
        }
        // fetch dashbaord context values including user details, stats only once 
        axios.all([
            axios.post(LAST_MESSAGE_URL),
            axios.post(SALES_URL),
            axios.post(MYPRODUCTS_URL, { userId: localStorage.getItem("id") }),
            axios.post(ORDERS_URL),
            axios.post(ADS_URL, { userId: localStorage.getItem("id") }),
            axios.post(USER_URL, { userId: localStorage.getItem("id") })
        ]).then(axios.spread((messagesResponse, salesResponse, productsResponse, ordersResponse, adsResponse, userResponse) => {
            let countUnreadedSales = 0
            let countUnreadedProducts = 0
            let countUnreadedOrders = 0
            let countUnreadedAds = 0



            salesResponse.data.forEach(sale => {
                if (!isReadedSale(sale.id)) {
                    countUnreadedSales++
                }
            })


            productsResponse.data.forEach(product => {
                if (!isReadedProduct(product.id)) {
                    countUnreadedProducts++
                }
            })


            ordersResponse.data.forEach(order => {
                if (!isReadedOrder(order.id)) {
                    countUnreadedOrders++
                }
            })


            adsResponse.data.forEach(ad => {
                if (!isReadedAd(ad.id)) {
                    countUnreadedAds++
                }
            })


            setunreadedChatUserIds(getUnReadedChats(messagesResponse))
            setcountUnreadedSales(countUnreadedSales)
            setcountUnreadedProducts(countUnreadedProducts)
            setcountUnreadedOrders(countUnreadedOrders)
            setcountUnreadedAds(countUnreadedAds)
            saveUnreadedSales(countUnreadedSales)
            saveUnreadedProducts(countUnreadedProducts)
            saveUnreadedOrders(countUnreadedOrders)
            saveUnreadedAds(countUnreadedAds)
            setuserData(userResponse.data)
        })).catch((err) => {
            showAlert("error", t("request.errorFetchDashboardDetials"))
        })
    }, [])




    if (isAuthenticated())
        return (
            <DashboardHeaderContext.Provider value={{ countUnreadedAds, setcountUnreadedAds, countUnreadedOrders, setcountUnreadedOrders, countUnreadedSales, setcountUnreadedSales, countUnreadedProducts, setcountUnreadedProducts, setfirstName, setlastName, setphoto, unreadedChatUserIds, setunreadedChatUserIds, setnavLinks, setpageTitle, setpageNavLink, setalertTitle }}>
                <DashboardHeaderComponent countUnreadedAds={countUnreadedAds} countUnreadedOrders={countUnreadedOrders} countUnreadedSales={countUnreadedSales} countUnreadedProducts={countUnreadedProducts} firstName={firstName} lastName={lastName} photo={photo} unreadedChatUserIds={unreadedChatUserIds} setunreadedChatUserIds={setunreadedChatUserIds} isAdminPath={isAdminPath} pageNavLink={pageNavLink} pageTitle={pageTitle} navLinks={navLinks} alertTitle={alertTitle}>
                    <Outlet />
                </DashboardHeaderComponent>
            </DashboardHeaderContext.Provider>
        )
}



function DashboardHeaderComponent({ countUnreadedAds, countUnreadedOrders, countUnreadedSales, countUnreadedProducts, firstName, lastName, photo, unreadedChatUserIds, setunreadedChatUserIds, isAdminPath, navLinks = [], pageTitle, pageNavLink, alertTitle, children }) {
    const { t } = useTranslation();
    const location = useLocation();
    const { language, setLanguage } = useContext(LanguageContext);
    const { currency, setCurrency } = useContext(CurrencyContext)
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [isSideBarOpen, setisSideBarOpen] = useState(!isSmallScreen)
    const [isNavMenuOpen, setisNavMenuOpen] = useState(false)

    useEffect(() => {
        if (isSideBarOpen) {
            document.body.classList.add("sidebar-enable")

        } else {
            document.body.classList.remove("sidebar-enable")
        }
    }, [isSideBarOpen])

    useEffect(() => {
        const path = location.pathname;

        if (path.startsWith("/dashboard/user/chat")) {
            setunreadedChatUserIds([])
            saveUnreadedChats([])
        }

        if (path.startsWith("/dashboard/user/myproducts")) {
            saveUnreadedProducts(0)
        }

        if (path.startsWith("/dashboard/user/mesannonces")) {
            saveUnreadedAds(0)
        }

        if (path.startsWith("/dashboard/user/mesventes")) {
            saveUnreadedSales(0)
        }

        if (path.startsWith("/dashboard/user/mesCommandes")) {
            saveUnreadedOrders(0)
        }
    }, [location.pathname, setunreadedChatUserIds])

    if (isAdminPath && !isAdminAccount()) {
        return (<NotFound fullSize={true} deniedAccess={true} />)
    }
    else
        return (
            <>
                {/* Header */}
                <div className="my-admin-1">
                    <header id="page-topbar">
                        <div className="navbar-header d-flex justify-content-between align-items-center">
                            {/* Left Section: Logo */}
                            <div className="d-flex">
                                {/* Left Section: Logo */}
                                <div
                                    className="navbar-brand-box"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: 0
                                    }}>
                                    <img
                                        src={require('../assets/FrontOffice/images/techoney.png')}
                                        alt="Logo"
                                        height={60}
                                    />
                                </div>

                                {/* Menu Button */}
                                <button
                                    type="button"
                                    className="btn btn-sm px-3 font-size-24 header-item waves-effect"
                                    id="vertical-menu-btn"
                                    onClick={() => setisSideBarOpen(!isSideBarOpen)}
                                >
                                    <i className="mdi mdi-menu"></i>
                                </button>
                            </div>

                            {/* Search Bar */}
                            <div className="search-wrap" id="search-wrap">
                                <div className="search-bar">
                                    <input
                                        className="search-input form-control"
                                        placeholder="Search"
                                    />
                                    <a
                                        href="#"
                                        className="close-search toggle-search"
                                        data-target="#search-wrap"
                                    >
                                        <i className="mdi mdi-close-circle"></i>
                                    </a>
                                </div>
                            </div>

                            {/* Notifications and User Dropdown */}
                            <div className="d-flex align-items-center">
                                <HeaderLanguageCurrency blackStyle={true} />



                                {/* Notification Dropdown 
                                <div className="dropdown d-inline-block">
                                    <button
                                        className="btn header-item waves-effect"
                                        id="page-header-notifications-dropdown"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="mdi mdi-bell"></i>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
                                        <div className="p-3">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h6 className="m-0"> Notifications </h6>
                                                </div>
                                                <div className="col-auto">
                                                    <a href="#!" className="small">
                                                        View All
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ maxHeight: 230 }}>
                                            
                                            <a href="#" className="text-reset notification-item">
                                                <div className="media">
                                                    <div className="avatar-xs me-3">
                                                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                                                            <i className="mdi mdi-cart text-white"></i>
                                                        </span>
                                                    </div>
                                                    <div className="media-body">
                                                        <h6 className="mt-0 mb-1">Your order is placed</h6>
                                                        <div className="font-size-13 text-muted">
                                                            <p className="mb-1">
                                                                If several languages coalesce the grammar
                                                            </p>
                                                            <p className="mb-0">
                                                                <i className="mdi mdi-clock-outline"></i> 3 min ago
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="p-2 border-top">
                                            <a
                                                className="btn btn-sm btn-link font-size-14 w-100 text-center"
                                                href="javascript:void(0)"
                                            >
                                                <i className="mdi mdi-arrow-right-circle me-1"></i> View
                                                More..
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                */}


                                {/* User Dropdown */}
                                <div className="dropdown d-inline-block">
                                    <button
                                        type="button"
                                        className="btn header-item waves-effect"
                                        id="page-header-user-dropdown"
                                        data-bs-toggle="dropdown"
                                        onClick={() => setisNavMenuOpen(!isNavMenuOpen)}
                                    >
                                        <span className="d-xl-inline-block ms-1">
                                            {firstName} {lastName}
                                        </span>
                                        <i className="mdi mdi-chevron-down d-xl-inline-block"></i>
                                    </button>
                                    <div className={"dropdown-menu dropdown-menu-end" + (isNavMenuOpen ? " show" : "")}>
                                        <NavLink className="dropdown-item" to="/">
                                            {t("homePage")}
                                        </NavLink>
                                        <div className="dropdown-divider"></div>
                                        <NavLink
                                            to="/login"
                                            className="dropdown-item text-danger"
                                            onClick={() => onUserLogout()}
                                        >
                                            {t("navigation13.1")}
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>

                    {/* Sidebar */}
                    <div className="vertical-menu">
                        <div className="h-100">
                            <div className="user-sidebar text-center ttm-bgcolor-darkgrey">
                                <div className="dropdown">
                                    <div className="user-img">
                                        {photo && photo !== "null" ? (
                                            <img
                                                src={`${Global.backend}/uploads/${photo}`}
                                                alt=""
                                                className="rounded-circle"
                                            />
                                        ) : (
                                            <img
                                                src={require("../assets/FrontOffice/images/avatar.png")}
                                                alt=""
                                                className="rounded-circle"
                                            />
                                        )}
                                        <span className="avatar-online bg-success"></span>
                                    </div>
                                    <div className="user-info">
                                        <h6 className="text-white">
                                            {firstName} {lastName}
                                        </h6>
                                    </div>
                                </div>
                            </div>

                            <div id="sidebar-menu">
                                <ul className="metismenu list-unstyled" id="side-menu">
                                    <li className="menu-title">Menu</li>

                                    <li>
                                        <NavLink to="/dashboard" className="waves-effect">
                                            <i className="dripicons-home"></i>
                                            <span>{t("navigation12.1")}</span>
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to="/dashboard/user/chat"
                                            className="waves-effect"
                                            onClick={() => {
                                                setunreadedChatUserIds([])
                                                saveUnreadedChats([])
                                            }}
                                        >
                                            <i className="dripicons-message"></i>
                                            <span>
                                                {t("myMessages")}
                                                {unreadedChatUserIds.length != 0 && (
                                                    <span className="badge rounded-pill bg-danger float-end">
                                                        {unreadedChatUserIds.length}
                                                    </span>
                                                )}
                                            </span>
                                        </NavLink>
                                    </li>

                                    {isBusinessAccountType() &&
                                        <>
                                            <li>
                                                <NavLink
                                                    to="/dashboard/user/myproducts"
                                                    className="waves-effect"
                                                    onClick={() => {
                                                        saveUnreadedProducts(0)
                                                    }}
                                                >
                                                    <i className="dripicons-basket"></i>
                                                    <span>
                                                        {t("myProducts")}
                                                        {countUnreadedProducts != 0 && (
                                                            <span className="badge rounded-pill bg-danger float-end">
                                                                {countUnreadedProducts}
                                                            </span>
                                                        )}
                                                    </span>
                                                </NavLink>
                                            </li>


                                            <li>
                                                <NavLink
                                                    to="/dashboard/user/mesannonces"
                                                    className="waves-effect"
                                                    onClick={() => {
                                                        saveUnreadedAds(0)
                                                    }}
                                                >
                                                    <i className="dripicons-to-do"></i>
                                                    <span>{t("myAds")}
                                                        {countUnreadedAds != 0 && (
                                                            <span className="badge rounded-pill bg-danger float-end">
                                                                {countUnreadedAds}
                                                            </span>
                                                        )}
                                                    </span>
                                                </NavLink>
                                            </li>


                                            <li>
                                                <NavLink
                                                    to="/dashboard/user/mesventes"
                                                    className="waves-effect"
                                                    onClick={() => {
                                                        saveUnreadedSales(0)
                                                    }}
                                                >
                                                    <i className="ti-truck"></i>
                                                    <span>
                                                        {t("mySales")}
                                                        {countUnreadedSales != 0 && (
                                                            <span className="badge rounded-pill bg-danger float-end">
                                                                {countUnreadedSales}
                                                            </span>
                                                        )}
                                                    </span>
                                                </NavLink>
                                            </li>
                                        </>
                                    }

                                    {!isAdminAccount() &&
                                        <li>
                                            <NavLink
                                                to="/dashboard/user/mesCommandes"
                                                className="waves-effect"
                                                onClick={() => {
                                                    saveUnreadedOrders(0)
                                                }}
                                            >
                                                <i className="dripicons-cart"></i>
                                                <span>{t("myOrders")}
                                                    {countUnreadedOrders != 0 && (
                                                        <span className="badge rounded-pill bg-danger float-end">
                                                            {countUnreadedOrders}
                                                        </span>
                                                    )}
                                                </span>
                                            </NavLink>
                                        </li>
                                    }



                                    <li>
                                        <NavLink to="/dashboard/user/modifierprofile" className="waves-effect">
                                            <i className="dripicons-user"></i>

                                            <span>{t("profile.1")}</span>
                                            {isBusinessAccountType() && !isStripePaymentConnected() &&
                                                <span className="translate-middle" style={{ position: "absolute", top: "50%", left: "90%" }}>
                                                    <NewReleasesIcon color="error" />
                                                </span>
                                            }
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink to="/dashboard/user/changermotdepasse" className="waves-effect">
                                            <i className="dripicons-lock"></i>
                                            <span>{t("changePassword")}</span>
                                        </NavLink>
                                    </li>

                                    {isAdminAccount() &&
                                        <>
                                            <li>
                                                <NavLink to="/dashboard/admin/adminusers">
                                                    <i className="dripicons-user-group"></i>
                                                    <span>{t("users")}</span>
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink to="/dashboard/admin/products">
                                                    <i className="dripicons-basket"></i>
                                                    <span>{t("products")}</span>
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink to="/dashboard/admin/orders">
                                                    <i className="dripicons-cart"></i>
                                                    <span>{t("orders")}</span>
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink to="/dashboard/admin/annonces-admin">
                                                    <i className="dripicons-to-do"></i>
                                                    <span>{t("navigation7.1")}</span>
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink to="/dashboard/admin/adminactualitelist">
                                                    <i className="dripicons-checklist"></i>
                                                    <span>{t("navigation8.1")}</span>
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink to="/dashboard/admin/contact">
                                                    <i className="dripicons-mail"></i>
                                                    <span>{t("inbox")}</span>
                                                </NavLink>
                                            </li>
                                        </>
                                    }
                                </ul>
                            </div>

                        </div>
                    </div>


                    {/* Page Content */}
                    <div className="main-content ttm-bgcolor-grey" style={{ minHeight: "100vh" }}>
                        <div className="page-content">
                            <div className="page-title-box ttm-bgcolor-darkgrey">
                                <div className="container-fluid">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <div className="page-title">
                                                <h4>{t(pageTitle)}</h4>
                                                <ol className="breadcrumb m-0">
                                                    <li className="breadcrumb-item fs-4">
                                                        <NavLink to={isAdminPath ? "/dashboard/admin" : "/dashboard"}>
                                                            Techoney
                                                        </NavLink>
                                                    </li>
                                                    {navLinks.map((link, index) => (
                                                        <li className="breadcrumb-item fs-4" key={index}>
                                                            <NavLink to={link.path}>
                                                                {t(link.label)}
                                                            </NavLink>
                                                        </li>
                                                    ))}
                                                    <li className="breadcrumb-item fs-5 active">{t(pageTitle)}</li>
                                                </ol>
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="float-end d-none d-sm-block">
                                                <NavLink className="btn btn-success" style={{ color: 'white' }} to={pageNavLink.path}>
                                                    {t(pageNavLink.label)}
                                                </NavLink>
                                            </div>
                                        </div>


                                        {alertTitle &&
                                            <div className="alert alert-warning" role="alert">
                                                {t(alertTitle)}
                                            </div>
                                        }



                                    </div>
                                </div>
                            </div>

                            <div className="container-fluid bg-trasparent my-4 p-3">
                                <div className="row">

                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )


};